import { uniqueId } from "lodash-es";
import type { Group, TrackType } from "./Base";
import { UnitFrame2μs } from "../data/trackConfig";
import { audioDecoder, splitClip } from "@/utils/webcodecs";
import { OffscreenSprite } from "@webav/av-cliper";

export interface AudioMaterial {
  id: string;
  url?: string;
  name?: string;
  format?: string;
  duration?: number;
  [k: string]: any;
}

export class AudioGroup implements Group {
  id: string;
  type: TrackType = "audio";
  materials: AudioMaterial[];
  activeSourceIndex: number;
  name: string;
  format: string;
  frameCount: number;
  start: number;
  end: number;
  offsetL: number;
  offsetR: number;
  [k: string]: any;

  constructor(
    materials: AudioMaterial[],
    options: { start?: number; frameCount?: number }
  ) {
    // 设置ID
    this.id = uniqueId();
    this.activeSourceIndex = 0;
    // 设置音频信息
    this.materials = materials;
    // 获取文件名称
    this.name = "音频";
    // 获取文件类型
    this.format = "";
    this.frameCount = options.frameCount ?? 5000;
    this.start = options.start ?? 0;
    this.end = this.start + this.frameCount;

    // 设置裁剪信息
    this.offsetL = 0;
    this.offsetR = 0;
  }
  audio: HTMLAudioElement | null = null;
  play(currentFrame: number) {
    alert("play");
    if (!this.audio) {
      // this.audio = new Audio(this.source.url);
    }
    if (this.audio?.paused) {
      // this.audio.currentTime = (currentFrame - this.start - this.offsetL) / 30;
      // this.audio.play();
    }
  }
  pause() {
    if (this.audio && !this.audio.paused) {
      this.audio.pause();
    }
  }
  // 生成合成对象
  async combine() {
    const audio = await audioDecoder.decode({
      id: this.materials[this.activeSourceIndex].id,
    });
    const clip = await splitClip(audio, {
      offsetL: this.offsetL,
      offsetR: this.offsetR,
      frameCount: this.frameCount,
    });
    if (!clip) {
      throw new Error("clip is not ready");
    }
    const spr = new OffscreenSprite(clip);
    // TODO：需要支持裁剪
    spr.time = {
      offset: this.start * UnitFrame2μs,
      duration: (this.end - this.start) * UnitFrame2μs,
    };

    return spr;
  }
}
